import React from 'react'
import banner from '../images/portfolio-banner.png';
// import { HiArrowNarrowRight } from 'react-icons/hi';
// import { TbWorldShare } from 'react-icons/tb';
import { useTranslation } from 'react-i18next';
// import iklimbilinci from '../images/iklimbilinci.png';
// import websiteportfolio from '../images/example-website-portfolio.png';
// import menuapp from '../images/menu-app-portfolio.png';
// import petworldportfolio from '../images/petworld-portfolio.png';
// import eCommerce from '../images/e-commerce.png';
 // import countries from '../images/countries.png';
// import englishTests from '../images/english-tests.png';
// import todoList from '../images/todo-list.png';
 import PropTypes from 'prop-types';
// import purchasingpower from '../images/react-purchasing-power.png';
import '../index.css';
import { useEffect, useState } from 'react';
import { MdArrowDropDown } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import {Projects} from '../Projects.js';
import Project from './Project.jsx';
import ProjectDisplayWindow from './ProjectDisplayWindow.jsx';


const ProjectsPortfolio = ({visibleServices,setVisibleServices}) => {
  const { t } = useTranslation();
  const [currentSelectedProjectId,setCurrentSelectedProjectId] = useState(1);
  const [currentSelectedProject,setCurrentSelectedProject] = useState({});
  const [totalProjectsCount,setTotalProjectsCount] = useState();
  const [popupVisibility,setPopupVisibility] = useState(false);


  useEffect(()=>{

    if(Projects){

   
    const found = Projects.find((eachProject)=>eachProject.id==currentSelectedProjectId);
    if(found){
      setCurrentSelectedProject(found);
    }
    setTotalProjectsCount(Projects.length);
  }
   
  },[currentSelectedProjectId,Project])

  return (
    <div id='portfolio'>  
      <div id='portfolio-banner' className='w-full mt-16 flex justify-center flex-col relative items-center'>
        <div className='flex z-10  w-fit flex-row items-center phone-450:absolute phone-450:gap-16 gap-3'>
        <span className='border-b-2 py-2 px-4 font-bold text-2xl cursor-pointer '>{t("Portfolio")}</span>
        <span className='border-b border-app-dark/0 py-2 px-4 hover:border-app-dark/100 text-2xl cursor-pointer' onClick={()=> setVisibleServices(!visibleServices)} >{t("Services")}</span>
        </div>
      
       <img src={banner} alt="" className='relative z-0 phone-450:block hidden' />
    </div>

    <div className='w-full  p-4 flex justify-center max-[1050px]:flex-col max-[600px]:px-4 gap-24 max-[1050px]:gap-4 items-center'>
    
    <div className=' gap-4 flex flex-col max-[1050px]:w-full w-fit justify-start  max-[1050px]:items-center  items-start'>
  

        <div onClick={()=>{setPopupVisibility(!popupVisibility)}} className={`hidden ${popupVisibility ? '  rounded-t-md' : 'rounded-md'} relative z-[1] max-w-[750px] max-[1050px]:flex cursor-pointer pointer-events-none max-[1050px]:pointer-events-auto h-12 justify-between bg-app-socailmedias-bg text-app-black  px-2 items-center w-full`}>
          <span className='font-medium'>{currentSelectedProject.title}</span>
         {popupVisibility ? <IoClose size={20} className='text-app-dark'/>  :  <MdArrowDropDown  className='text-app-dark' size={20}/>}

          <div style={{display: popupVisibility ? 'flex' : 'none'}} className={`absolute shadow-[0_3px_6px_rgba(255,255,255,0.1)] bg-app-socailmedias-bg flex-col gap-2 p-2  rounded-b-md w-full left-0  top-[45px] z-[2]  min-h-[120px]`}>
          {Projects.filter(eachProject => eachProject.id !== currentSelectedProjectId).map((eachProject, i) => (
  <div 
    key={'popup-nav-' + i} 
    onClick={() => setCurrentSelectedProjectId(eachProject.id)} 
    className={`w-full flex text-app-dark p-1 rounded-md hover:underline underline-offset-2`}
  >
    {eachProject.title}
  </div>
))}

          </div>
        </div>
        
        
         
            <div className='flex justify-center max-[1050px]:hidden  items-stretch gap-4  '>
          <div className='w-[3px] bg-[#1D1D1D]  my-2 items-stretch rounded-md'></div>
       
         <div className='projects-container   flex  flex-col flex-1 gap-4'>

          {Projects.map((eachProject,i)=>{
            return  <Project key={"Projects-"+i} active={currentSelectedProjectId==eachProject.id} setCurrentSelectedProjectId={setCurrentSelectedProjectId}  projectData={eachProject}/>
          })}
      

         </div>
        </div>
         
        

    </div>
  <ProjectDisplayWindow totalProjectsCount={totalProjectsCount} setCurrentSelectedProjectId={setCurrentSelectedProjectId} selectedProject={currentSelectedProject}/>
  </div>
     

    
    <div className='w-full h-16 bg-app-dark flex justify-center items-center text-app-white font-bold text-base'>{t("And Many More")}</div>
    </div>
  )
}
ProjectsPortfolio.propTypes = {
  visibleServices: PropTypes.bool,
  setVisibleServices:PropTypes.func
};

export default ProjectsPortfolio